import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import VerifyPassword from "../verify_password_info/VerifyPassword";

function VerifyPasswordLanding(){
    return(
        <div>
            <Header />
            <VerifyPassword />
            <Footer />
        </div>
    )
}

export default VerifyPasswordLanding